import { render, staticRenderFns } from "./edit-form.vue?vue&type=template&id=5b8d918c&scoped=true&"
import script from "./edit-form.vue?vue&type=script&lang=js&"
export * from "./edit-form.vue?vue&type=script&lang=js&"
import style0 from "./edit-form.vue?vue&type=style&index=0&id=5b8d918c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8d918c",
  null
  
)

export default component.exports